"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ponziRulesSearchValuesCreator = void 0;
const types_1 = require("@framework/types");
const types_2 = require("../../../../../types");
const ponziRulesSearchValuesCreator = profile => ({
    [types_2.ServiceType.ADMIN]: {
        ponziRuleStatus: [types_1.PonziRuleStatus.ACTIVE, types_1.PonziRuleStatus.NEW],
    },
    [types_2.ServiceType.OFFICE]: {
        ponziRuleStatus: [types_1.PonziRuleStatus.ACTIVE, types_1.PonziRuleStatus.NEW],
        merchantId: profile.merchantId,
    },
});
exports.ponziRulesSearchValuesCreator = ponziRulesSearchValuesCreator;
//# sourceMappingURL=schemas.js.map